module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none mr-auto"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarToggle
    }
  }, [_vm._v("☰")])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav mr-3"
  }, [_c('li', {
    staticClass: "nav-item d-md-down-none"
  }, [_c('b-dropdown', {
    staticClass: "m-sm-3",
    attrs: {
      "text": _vm.realm.name,
      "right": "",
      "disabled": _vm.realms.length == 1
    }
  }, _vm._l((_vm.realms), function(item) {
    return _c('b-dropdown-item', {
      key: item.id,
      on: {
        "click": function($event) {
          _vm.changeRealm(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1), _vm._v(" "), _c('dropdown', {
    staticClass: "nav-item",
    attrs: {
      "size": "nav"
    }
  }, [_c('span', {
    slot: "button"
  }, [_c('img', {
    staticClass: "img-avatar",
    staticStyle: {
      "border-radius": "0px"
    },
    attrs: {
      "src": require("../assets/user-avatar.png"),
      "alt": "avatar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right",
    slot: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-header text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.firstname))])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout")])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-04fcf65c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04fcf65c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 1552
// module chunks = 1